<script setup lang="ts">
import type { Product } from '~/types/shopware'
import { getProductFeatures } from '~/lib/utils/shopware'

const { t } = useI18n()

const props = defineProps<{
  product: Product
}>()

const features = computed(() => getProductFeatures(props.product))
const featureContent = computed(() => {
  return {
    'audio-file': {
      label: t('shop.productPage.features.audioFile'),
      icon: '/img/product-features/audio-file.svg',
    },
    'digital-study-questions': {
      label: t('shop.productPage.features.digitalStudyQuestions'),
      icon: '/img/product-features/digital-study-questions.svg',
    },
    podcast: {
      label: t('shop.productPage.features.podcast'),
      icon: '/img/product-features/podcast.svg',
    },
    'simplified-language': {
      label: t('shop.productPage.features.simplifiedLanguage'),
      icon: '/img/product-features/simplified-language.svg',
    },
    'study-avatar': {
      label: t('shop.productPage.features.studyAvatar'),
      icon: '/img/product-features/study-avatar.svg',
    },
    video: {
      label: t('shop.productPage.features.video'),
      icon: '/img/product-features/video.svg',
    },
  } as Record<string, { label: string; icon: string }>
})
const visibleFeatures = computed(() =>
  features.value
    .map((feature) => featureContent.value[feature])
    .filter((feature): feature is { label: string; icon: string } => Boolean(feature)),
)
</script>
<template>
  <ul v-if="visibleFeatures.length" class="cul features">
    <li v-for="(feature, index) in visibleFeatures" :key="index" class="text-xsmall">
      <img :src="feature.icon" />
      {{ feature.label }}
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.features {
  display: grid;
  grid-template-columns: 100%;
  gap: 16px;
  @include breakpoint(ml) {
    grid-template-columns: 1fr 1fr;
  }
  li {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 12px;
    align-items: center;
    img {
      width: 44px;
    }
  }
}
</style>
